var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"title":_vm.$t('eip.nav.operationManual')},on:{"click":_vm.openHandbook}},[_c('i',{staticClass:"iconfont icon-bpm-record"})])}
var staticRenderFns = []

export { render, staticRenderFns }